/**
 * All UI Config Model for any App
 */

// TODO: We need replace the source in users.service.ts
export const CLASS_VALUATION_PROVIDER = 'classvaluation';
export const CLASS_APP_KEY = 'app';
export const CLASS_ORG_ID = 'organizationId';

export enum UIConfigStatus {
	READY = 'ready',
	PRISTINE = 'pristine',
	NONE = 'none'
}

export class UIConfigStateModel {
	status: UIConfigStatus;
	application: AppUIConfigModel;
	reports?: any; // Not as part of this core app, but defined

	constructor() {
		this.status = UIConfigStatus.PRISTINE;
	}
}

export class AppUIConfigModel {
	[appName: string]: UIStylePropertyModel;
}

export interface UIStylePropertyModel {
	logo?: string;
	favIcon?: string;
	style?: any | UIConfigStyle;
}

export class UIConfigStyle {
	show?: boolean;
	// Any Type until we defined a set
	[property: string]: any;
}
